import { useState } from 'react';
import questiontwo from '../../assets/icons/Icon.svg';
import { CustomModal } from 'components/common/CustomModal';
import apiService from 'services/apiService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ApplyForm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const savedData = JSON.parse(localStorage.getItem('rowOriginalData'));

  let title = localStorage.getItem('title');

  const user = JSON.parse(localStorage.getItem('user'));

  const navigate = useNavigate();

  console.log('savedDatasavedData', savedData);

  const capitalizeFirstCharacter = (str) => {
    if (!str) return ''; // Handle empty or undefined strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  // Check if the value is null or empty before parsing
  if (title) {
    try {
      title = JSON.parse(savedData);
    } catch (error) {
      title = null; // Fallback value
    }
  } else {
    title = null; // Fallback value if empty or null
  }

  const Apply = async (data) => {
    try {
      const payload = {
        announced_job_id: data, // Use a colon (:) instead of an equal sign (=)
      };

      const response = await apiService.post(
        'announced-jobs/applicants/apply',
        payload
      );

      if (response.code === 201) {
        toast.success('Application submitted successfully!', {
          toastId: '19q',
        });
        navigate('/Announcement');
      } else {
        toast.error(response.message || 'Failed to submit application.', {
          toastId: '2e0',
        });
      }
    } catch (error) {
      console.error('Error while applying:', error?.response?.data?.message);

      // Display error message to the user
      toast.error(
        error?.response?.data?.message ||
          'Something went wrong. Please try again later.',
        {
          toastId: '21',
        }
      );
    }
  };

  const parseDate = (dateString) => {
    if (!dateString) return '';

    // Try to parse ISO format (YYYY-MM-DDTHH:mm:ss.sssZ)
    if (dateString.includes('T')) {
      return new Date(dateString);
    }

    // Try to parse MM/DD/YYYY format
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const formattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`; // Convert to YYYY-MM-DD
      return new Date(formattedDate);
    }

    return new Date(dateString); // Fallback
  };

  const formattedTillDate = savedData?.till
    ? new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      }).format(parseDate(savedData.till))
    : '';

  return (
    <>
      <div className="bg-white rounded-lg p-6">
        {isModalOpen && (
          <div className="fixed z-[9999] inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white rounded-lg shadow-md w-1/3">
              <div className="px-4 pt-4 pb-2 flex space-x-3">
                <img src={questiontwo} alt="logo" className="self-start" />
                <div>
                  <h3 className="text-lg font-medium text-gray-900">
                    Confirmation to apply
                  </h3>
                  <p className="text-sm text-gray-600">
                    Please confirm that you want to apply. This action cannot be
                    undone.
                  </p>
                </div>
              </div>
              <div className="flex justify-end space-x-2 p-3 border-t border-[#E2E4E9]">
                <button
                  // onClick={onDismiss}
                  className="px-3 py-2 text-gray-700 rounded-lg hover:bg-gray-200 border border-[#E2E4E9]"
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                >
                  Dismiss
                </button>
                <button
                  // onClick={onConfirm}
                  className="px-3 py-2 bg-[#176448] text-white rounded-lg hover:bg-green-700"
                  onClick={() => {
                    Apply(savedData._id);
                    setIsModalOpen(false);
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="border rounded  pt-6 pl-1 pr-1">
          <div class="flex justify-between items-center border-b pb-2 pl-2 pr-2">
            <div class="flex items-center gap-2">
              <span class="flex items-center gap-1 px-2 py-1 text-sm font-semibold text-[#525866] bg-[#ffffff] border rounded">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8.84082" cy="8.33105" r="3" fill="#38C793" />
                </svg>
                {savedData?.applications?.find(
                  (item) => item.user_id === user.id
                )?.status === 'rejected'
                  ? 'Rejected'
                  : savedData?.applications?.some(
                        (item) => item.user_id === user.id
                      )
                    ? 'Applied'
                    : capitalizeFirstCharacter(savedData?.status)}
              </span>
              <h1 class="text-lg font-semibold ml-4">
                {savedData?.medical_speciality?.name} Specialist
              </h1>
            </div>

            {savedData?.applications?.some((item) => item.user_id === user.id)
              ? null
              : savedData?.status != 'closed' && (
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="flex items-center justify-center gap-2 bg-[#2D9F75] text-white w-[100px] font-medium px-4 py-2 rounded-md"
                  >
                    Apply
                  </button>
                )}
          </div>

          <div className="mb-6">
            {/* First Row with 5 columns */}
            <div className="grid grid-cols-5 gap-4 text-sm h-[120px]">
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Date Posted
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {new Date(savedData.created_at).toLocaleDateString('en-GB')}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Location
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {savedData?.creator?.sites?.[0]?.name}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  No Of Positions
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {savedData?.no_of_practitioners}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Level
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {savedData?.medical_speciality?.name}
                </p>
              </div>
              <div className="pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Expiry Date
                </p>
                <p className="text-[#AF1D38] font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {formattedTillDate}
                </p>
              </div>
            </div>

            {/* Second Row with 3 columns */}
            <div className="grid grid-cols-3 gap-4 text-sm border-t border-b h-[120px]">
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Hospital Name
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {savedData?.creator?.sites?.[0]?.name}
                </p>
              </div>
              <div className="border-r pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  Region
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  {savedData?.creator?.region.name}
                </p>
              </div>
              <div className="pt-4">
                <p className="font-inter text-xs font-medium leading-4 text-left underline-from-font decoration-none text-[#868C98]">
                  City
                </p>
                <p className="font-inter text-base font-semibold leading-6 tracking-[-0.011em]">
                  Medina
                </p>
              </div>
            </div>
          </div>

          <span className="text-[#868C98] text-[16px] font-semibold ">
            Job Summary{' '}
          </span>
          <div
            className="relative overflow-hidden pt-3"
            dangerouslySetInnerHTML={{
              __html: savedData?.job_description || '',
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ApplyForm;
